import styled from 'styled-components'
import { Button } from "components/Buttons/styles";
import { InputBlock, LeftBlock, Wrapper } from 'components/Input/styles';

export const Container = styled.div`
	margin: auto;
	margin-top: 18vh;
	max-width: 50.8rem;
	width: 100%;
	height: fit-content;
	display: flex;
	flex-direction: column;
	${Button} {
		width: 100%;
	}
	${Wrapper} {
		height: 7rem;
		width: 100%;
		input {
			height: 7rem;
		}
		${LeftBlock} {
			left: 2.4rem;
		}
		${InputBlock} {
			padding-left: 5.6rem;
		}
	}
`;

export const Row = styled.div`
	margin-top: ${props => props.top};
	display: flex;
	align-items: ${props => props.alignItems ? props.alignItems : "center"};
	justify-content: ${props => props.justifyContent ? props.justifyContent : "space-between"};
	gap: ${props => props.gap ? props.gap : "1.2rem"};
	margin-bottom: ${props => props.bottom};
`;

export const Column = styled.div`
	display: flex;
	flex-direction: column;
	align-items: ${props => props.alignItems ? props.alignItems : "center"};
	gap: ${props => props.gap ? props.gap : "1.2rem"};
	margin-bottom: ${props => props.bottom};
`;

export const Title = styled.div`
	${props => props.theme.fonts.interSemibold32};
	color: ${props => props.theme.colors.white100};
`;

export const Subtitle = styled.div`
	${props => props.theme.fonts.interMedium13}
	color: ${props => props.theme.colors.secondary};
	margin-bottom: 2rem;
`;

export const InputCell = styled.div`
	${props => props.theme.fonts.interSemibold32}
	color: ${props => props.theme.colors.white100};
	height: 10rem;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: .15s all;
	width: 100%;
	border-radius: 1.2rem;
	border: .1rem solid ${props => props.theme.colors.darkBlue};
	&.active {
		border: .3rem solid ${props => props.theme.colors.darkBlue};
	}
`;

export const Timer = styled.div`
	${props => props.theme.fonts.interSemibold13};
	color: ${props => props.theme.colors.secondary};
	height: 4rem;
	display: flex;
	gap: .8rem;
	align-items: center;
	span.white {
		color: ${props => props.theme.colors.white100};
	}
`